module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedicationa"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0006-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('strong', [_vm._v("This book is dedicated to Mom and Dad for always encouraging me,"), _c('br'), _vm._v("and my brother, Tom, for renewing my interest in rap music.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb6c9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0